import { ComposedChart, BarChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const MixBarChart = (props: Props) => {
  return (
    <div className="w-full h-full ">
      <h1 className="mb-5">{props.title}</h1>
      <div className="">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={props.chartData}>
          <CartesianGrid strokeDasharray="1 5" />
          <XAxis dataKey={props.xaxisKey} 
            tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#688394' }}
            axisLine={{ stroke: '#EAF0F4' }} 
            style={{
              fontSize: '10px',
              // fontFamily: 'Times New Roman',
            }}
          />
          <YAxis 
            tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#688394' }}
            axisLine={{ stroke: '#EAF0F4' }} 
            style={{
              fontSize: '10px',
              // fontFamily: 'Times New Roman',
            }}
          />
            <Tooltip
              contentStyle={{ background: "#146289", borderRadius: "5px" }}
            //   labelStyle={{ display: "none" }}
              cursor={{fill:"#5d6164b6"}}
            />
            <Legend />
            <Bar dataKey={props.stackA} stackId="a" fill={props.bar1color} />
            <Bar dataKey={props.stackB} stackId="a" fill={props.bar2color} />
            <Bar dataKey={props.dataKey} fill={props.bar3color} />
            {/* <Line type="monotone" dataKey={props.dataKey} stroke={props.bar3color} /> */}
            </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default MixBarChart